export const Permissions = {
  create: "create:Page",
  read: "read:Page",
  list: "list:Page",
  update: "update:Page",
  delete: "delete:Page",
};
